import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

const Select = React.forwardRef(
  ({ className, children, label, ...props }, ref) => {
    return (
      <>
        {label && <label className="font-bold">{label}</label>}
        <div className="relative">
          <select
            className={cn(
              "flex px-3 py-2 pr-10 w-full h-10 text-base rounded-md border appearance-none border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
              className
            )}
            ref={ref}
            {...props}
          >
            {children}
          </select>
          <ChevronDown
            className="absolute right-3 top-1/2 -translate-y-1/2"
            size={18}
          />
        </div>
      </>
    );
  }
);

Select.displayName = "Select";

export { Select };
